/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');

    /* Fix 2026-09-01: these handlers used to bind directly to the two trigger nodes,
       once, on window load. #MobileFilterTrigger lives inside the horizontal filter
       bar, and AJAX filtering replaces that bar — so after the first filter the
       swapped-in trigger had no listener and the drawer would not reopen. The <a> then
       just navigated to #SideFilters. Delegating from the document keeps the handler
       working across any number of swaps, and resolves the drawer at click time rather
       than capturing a possibly-stale reference. The bound flag matters because
       Cloudflare Rocket Loader replays script activation, so this can construct twice. */
    if (!document.__facetsToggleBound) {
      document.__facetsToggleBound = true;

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest && e.target.closest('#Facets-Toggle, #MobileFilterTrigger');
        if (!trigger) return;

        const container = document.getElementById('Facet-Drawer');
        if (!container) return;

        e.preventDefault();
        const body = document.getElementsByTagName('body')[0];

        if (trigger.id === 'MobileFilterTrigger') {
          body.classList.add('open-cc');
          container.classList.add('active');
        } else {
          body.classList.toggle('open-cc');
          container.classList.toggle('active');
        }
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);

    /* Fix 2026-09-10 (MOBILE-3): the mobile filter trigger is display:none from
       768px up, so a drawer left open while the viewport widens (rotation, split
       view, desktop resize) had no way to close, and .click-capture kept
       swallowing every click on the page. Close it when the breakpoint flips. */
    if (!document.__facetsDrawerMQBound && window.matchMedia) {
      document.__facetsDrawerMQBound = true;
      const mq = window.matchMedia('(min-width: 768px)');
      const closeIfOpen = () => {
        if (!mq.matches) return;
        const drawer = document.getElementById('Facet-Drawer');
        if (drawer && drawer.classList.contains('active')) {
          drawer.classList.remove('active');
          document.body.classList.remove('open-cc');
        }
      };
      if (mq.addEventListener) mq.addEventListener('change', closeIfOpen);
      else if (mq.addListener) mq.addListener(closeIfOpen);
    }
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    /* Fix 2026-09-07: never assume either side of the swap exists. If the fetched
       section has no grid, clear the loading state instead of leaving it greyed out. */
    const sourceGrid = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    const currentGrid = document.getElementById('ProductGridContainer');
    if (!sourceGrid || !currentGrid) {
      const loading = currentGrid && currentGrid.querySelector('.collection.loading');
      if (loading) loading.classList.remove('loading');
      return;
    }
    currentGrid.innerHTML = sourceGrid.innerHTML;

    let top = currentGrid.getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    /* Fix 2026-09-07: rows used to be matched by data-index, which is the Liquid
       forloop position. On /search the filter set changes with the result set (a
       Price filter appears once the results share a price range, and so on), so
       the indexes in the fetched section no longer line up with the ones on the
       page. The old code then set innerHTML on a null querySelector result, threw
       inside the fetch promise, and the product grid stayed greyed out forever.
       Match rows by label inside the same form instead, fall back to the index,
       and never assume the target exists. */
    const labelOf = (row) => {
      const summary = row.querySelector('summary, .thb-filter-title');
      return summary ? summary.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
    };
    const findTarget = (element) => {
      const form = element.closest('form');
      const scope = (form && form.id && document.getElementById(form.id)) || document;
      const label = labelOf(element);
      let target = label
        ? Array.from(scope.querySelectorAll('collapsible-row')).find((row) => labelOf(row) === label)
        : null;
      if (!target) target = scope.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`);
      return target || null;
    };

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const jsFilter = event && event.target && event.target.closest ? event.target.closest('collapsible-row') : null;
    const jsFilterLabel = jsFilter ? labelOf(jsFilter) : '';
    const matchesIndex = (element) => {
      if (!jsFilter) return false;
      return jsFilterLabel ? labelOf(element) === jsFilterLabel : element.dataset.index === jsFilter.dataset.index;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = findTarget(element);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender && jsFilter) FacetFiltersForm.renderCounts(countsToRender, jsFilter);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!activeFacetsElement || !currentElement) return;
      currentElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!sourceElement || !currentElement) return;
      currentElement.innerHTML = sourceElement.innerHTML;
    });

  }

  static renderCounts(source, target) {
    if (!source || !target) return;
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    /* Fix 2026-09-10 (PERF-6): nouislider.js is a synchronous tag and this file is
       deferred, so the library is normally present. If anything ever changes that
       order (defer, async loader, CDN hiccup) the slider used to die silently.
       Wait for it instead of assuming it, giving up after ~5s. */
    if (typeof noUiSlider === 'undefined') {
      this.__noUiWait = (this.__noUiWait || 0) + 1;
      if (this.__noUiWait <= 50) setTimeout(() => this.connectedCallback(), 100);
      return;
    }
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});
